import { ReactNode } from "react";

import useTypedContext from "hooks/useTypedContext";

import Typography from "../../Typography";
import { TileContext } from "../Context";
import styles from "./styles.module.css";

type TileDescriptionProps = {
  children: ReactNode;
};

const TileDescription = ({ children }: TileDescriptionProps) => {
  const { descriptionId } = useTypedContext(TileContext);

  return (
    <Typography id={descriptionId} tag="p" color="inherit" className={styles.description}>
      {children}
    </Typography>
  );
};

TileDescription.displayName = "DS.Tile.Description";

export default TileDescription;
